import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import Paper from '@mui/material/Paper';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { useNavigate, useLocation } from 'react-router';

export default function LabelBottomNavigation() {
  const [value, setValue] = React.useState('recents');
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        overflow: 'hidden',
        minHeight: '68px',
        zIndex: 1300,
        borderTopLeftRadius: 22,
        borderTopRightRadius: 22,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        sx={{
          minHeight: '68px',
          width: '100%',
          overflowX: 'auto',
          overflowY: 'hidden',
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
          '& .MuiBottomNavigationAction-root': {
            color: '#737985',
          },
          '& .Mui-selected': {
            color: '#ff5c67',
          },
        }}
      >
        <BottomNavigationAction
          label='Home'
          value='/'
          icon={<HomeIcon />}
          onClick={() => navigate('/')}
        />
        <BottomNavigationAction
          label='Search'
          value='/search'
          icon={<SearchIcon />}
          onClick={() => navigate('/search')}
        />
        <BottomNavigationAction
          label='Favorites'
          value='/favorites'
          icon={<FavoriteIcon />}
          onClick={() => navigate('/favorites')}
        />
        <BottomNavigationAction
          label='Account'
          value='/profile'
          icon={<AccountCircleRoundedIcon />}
          onClick={() => navigate('/profile')}
        />
      </BottomNavigation>
    </Paper>
  );
}
